import PropTypes from 'prop-types';
import * as React from 'react';
import type {ColumnAlignmentType} from './ColumnAlignment';
import * as ColumnAlignment from './ColumnAlignment';
import type {ColumnTypeType} from './ColumnType';
import * as ColumnType from './ColumnType';

export type ColumnPropType = {
    name: string,
    type?: ColumnTypeType,
    label: string,
    format?: (value: any) => React.ReactNode,
    component?: (value: any) => React.ReactNode,
    alignment?: ColumnAlignmentType,
    width?: string | number,
    clickDisabled: boolean,
    className: string,
}

export const columnPropType = PropTypes.shape({
    name: PropTypes.string.isRequired,
    type: PropTypes.oneOf(Object.values(ColumnType)),
    label: PropTypes.string,
    format: PropTypes.func,
    component: PropTypes.func,
    alignment: PropTypes.oneOf(Object.values(ColumnAlignment)),
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    clickDisabled: PropTypes.bool,
    className: PropTypes.string,
});

export const columnSynchronizerPropType = PropTypes.shape({
    addListener: PropTypes.func.isRequired,
    removeListener: PropTypes.func.isRequired,
    getWidth: PropTypes.func.isRequired,
    setWidth: PropTypes.func.isRequired,
});

export type RowIdPropType = number | string

export const rowIdPropType = PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
]);

export type RowPropType = {
    id: RowIdPropType
}

export const rowPropType = PropTypes.shape({
    id: rowIdPropType.isRequired,
});
